<template>
  <!-- <AutoModal :show="showModal" @close="showModal = false"> </AutoModal> -->

  <Header />
  <!-- <transition name="fade">
  </transition> -->
  <router-view :key="$route.fullPath" />

  <Footer />
</template>
<script>
import "@/assets/styles/index.scss";
// import { useRoute } from "vue-router";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
// import AutoModal from "@/views/AutoModal";

// import { onMounted } from 'vue';

export default {
  components: {
    Header,
    Footer,
    // AutoModal,
  },
  setup() {
    return {};
  },
  data() {
    // return { showModal: true };
  },
};
</script>
<style lang="scss" scope>
@use "@/assets/styles/settings/_variables.scss";
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 1s;
}
.fade-enter-active {
  transition-delay: 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/*
@media (min-width: 992px) {
  main {
    min-height: calc(100vh - (302px + 67px));
  }
}*/

/*
::-webkit-scrollbar {
  width: variables.$scrollbar-width;
}
::-webkit-scrollbar-track {
  background: variables.$track-color;
}
::-webkit-scrollbar-thumb {
  background: variables.$scroll-thumb;
}
::-webkit-scrollbar-thumb:hover {
  background: variables.$scroll-thumb-hover;
}
*/
</style>
